export default "__VITE_ASSET__DAMNu_Km__"